<script>
import compoment from '@/components/draggable/SmartComponents/basicComponents/Sinput/SInputPreview'
export default {
  name: 'SAgePreview',
  extends: compoment
}
</script>
